import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import { THEMES } from '../../../../configs/LayoutConfig';
import {
  icbTickerToCode,
  SYMBOL_TYPES,
  TRADING_VIEW_HIDE_LEFT_TOOLBAR,
  TRADING_VIEW_SYMBOL_EDIT_FILTER,
} from '../../../../core/services/Technical/DataFeed/Const';
import MessageHub from '../../../../core/signalr/SignalrMessageHub';
import { ChanelConfig } from '../../../../configs/GlobalConfig';
import ConstCommon from '../../../common/Const';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import store from '../../../app/store';
import {
  LAYOUT_ITEM_DESTROYED,
  LAYOUT_STACK_CREATED,
} from '../../../common/GoldenLayoutWrapper';
import { TYPE_DISABLE } from '../../../common/sync-component/Const';
import {
  commonConfig,
  customConfig,
  getOverrides,
  getStudiesOverrides,
} from '../../../helpers/Charting';
import {
  getDataFollowKeyByDot,
  getSyncComponentState,
  getSyncDefaultSearch,
  isNotLogin,
  //isNotLoginOrExpired,
  syncComponentSelector,
} from '../../../helpers/Common';
import EventEmitter, {
  CHARTING_SCREEN_SHOT_READY,
  GET_CHARTING_SCREEN_SHOT,
  SHOW_GUEST_POPUP,
  SYNC_COMPONENT_SEARCH,
  TRADING_VIEW_WIDGET_RESET_DATA,
  TRADING_VIEW_WRAPPER_DATA_MAIN_SYMBOL,
  TRADING_VIEW_WRAPPER_DATA_RESET,
  TRADING_VIEW_WRAPPER_DATA_RESOLUTION,
} from '../../../helpers/EventEmitter';
import Layout from '../../../helpers/Layout';
import { formatPercent } from '../../../helpers/Text';
//import { saveLayout } from '../../../main-layout/sidebar/reducer';
import { fetchTemplateRequest } from '../reducer';
import DataFeed from '../../../../core/services/Technical/DataFeed';
import LoadTemplatePopup from './components/load-template/LoadTemplatePopup';
import SaveTemplatePopup from './components/save-template/SaveTemplatePopup';
import { Provider } from '../context';
import SharePopup from './components/share-popup/SharePopup';
import {
  capitalizeFirstLetter,
  isQuarterlyData,
  takeScreenShot,
} from './helper';
import CommonConst from '../../../common/Const';
import linkUrlConfig from '../../../../configs/LinkUrlConfig';
import currentState from '../../../helpers/CurrentState';
import { customIndicatorsGetter } from './indicators';
import { WrapperData } from './WrapperData';
import { clearPrevFromParams } from '../../../../core/services/Technical/DataFeed/helpers';
import { isMobile, isSmallThanWidth } from '../../../helpers/Device';
import { setSymbolOrganCodeType } from '../../../../core/services/Technical/DataFeed/historyProvider';

const ITEM_DESTROYED_WAIT = 20;
const DEFAULT_SYMBOL = 'VNINDEX';
export const CHARTING_LOCAL_STORAGE_KEY = 'Charting/LOCAL_STORAGE_KEY';
export const CHARTING_MULTIPLIER_BY_CODE = 'Charting/MULTIPLIER_BY_CODE';

class TradingView extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isShowLoadTemplatePopup: false,
      isShowSaveTemplate: false,
      isShowShare: false,
    };

    this.rootRef = React.createRef();
    this.debounceOnItemDestroyed = debounce(
      this.reInitChartWhenLayoutChange,
      ITEM_DESTROYED_WAIT,
    );
    this.prevIsMaximised = false;
  }

  componentDidMount() {
    const { isNewWindow } = this.props;
    this.initTimeout = setTimeout(() => {
      this.initTradingView();
    }, 0);
    this.loadTemplate();
    window.addEventListener(
      LAYOUT_ITEM_DESTROYED,
      this.debounceOnItemDestroyed,
    );
    window.addEventListener(
      LAYOUT_STACK_CREATED,
      this.reInitChartWhenLayoutChange,
    );
    window.addEventListener('resize', this.onHideLeftToolbar);
    this.calcSize();
    this.onSetSymbolTypesDefault();
    this.onHideLeftToolbar(true);
    if (!isNewWindow) {
      Layout.layout.on('stateChanged', this.onGlStateChanged);
      EventEmitter.subscribe(GET_CHARTING_SCREEN_SHOT, this.getChartScreenShot);
    }
    EventEmitter.subscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
    window.addEventListener('message', this.onReceivePostMessage, false);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { theme } = this.props;
    if (theme !== prevProps.theme) {
      this.tvWidget.changeTheme(capitalizeFirstLetter(theme));
      this.tvWidget.applyOverrides(getOverrides(theme));
    }
  }

  componentWillUnmount() {
    clearTimeout(this.initTimeout);
    window.removeEventListener(
      LAYOUT_ITEM_DESTROYED,
      this.debounceOnItemDestroyed,
    );
    window.removeEventListener(
      LAYOUT_STACK_CREATED,
      this.reInitChartWhenLayoutChange,
    );
    clearTimeout(this.sizeTimeout);
    this.tvWidget = null;
    document.getElementById(this.getContainerId()).remove();
    clearPrevFromParams();
    EventEmitter.unsubscribe(GET_CHARTING_SCREEN_SHOT, this.getChartScreenShot);
    EventEmitter.unsubscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
    EventEmitter.unsubscribe(
      TRADING_VIEW_WIDGET_RESET_DATA,
      this.onWidgetResetData,
    );
    window.removeEventListener('message', this.onReceivePostMessage);
  }

  getCurrentSymbol = () => {
    return this.tvWidget.chart().symbol();
  };
  //Subscribe realtime
  onReceiveTicker = data => {
    try {
      const symbol = this.getCurrentSymbol();
      const ticker = data.find(
        item =>
          item.ticker && item.ticker.toLowerCase() === symbol.toLowerCase(),
      );
      if (ticker) {
        document.title = this.getDocumentTitle(symbol, ticker);
      }
    } catch (error) {
      console.log(error);
    }
  };

  onReceiveIndex = data => {
    const symbol = this.getCurrentSymbol();
    const index = data.find(
      item => item.comGroupCode.toLowerCase() === symbol.toLowerCase(),
    );
    if (index) {
      document.title = this.getDocumentTitle(symbol, {
        ...index,
        priceChange: index.indexChange,
        percentPriceChange: index.percentIndexChange,
      });
    }
  };

  onReceiveDerivative = data => {
    const symbol = this.getCurrentSymbol();
    const listDerivativeByDerivativeCode = store.getState()[COMMON_REDUCER_NAME]
      .listDerivativeByDerivativeCode;
    const derivative = data.find(item => {
      return (
        listDerivativeByDerivativeCode[
          item.derivativeCode
        ].organCode.toUpperCase() === symbol.toUpperCase()
      );
    });
    if (derivative) {
      document.title = this.getDocumentTitle(symbol, derivative);
    }
  };

  onReceiveCW = data => {
    const symbol = this.getCurrentSymbol();
    const coveredWarrant = data.find(
      item => item.ticker.toUpperCase() === symbol.toUpperCase(),
    );
    if (coveredWarrant) {
      document.title = this.getDocumentTitle(symbol, coveredWarrant);
    }
  };

  onReceiveSector = data => {
    try {
      const symbol = this.getCurrentSymbol();
      const sector = data.find(
        item => item.icbCode && +item.icbCode === +icbTickerToCode[symbol],
      );
      if (sector) {
        document.title = this.getDocumentTitle(symbol, sector);
      }
    } catch (error) {
      console.log(error);
    }
  };

  getDocumentTitle = (symbol, price) => {
    const prefix = price.percentPriceChange > 0 ? '+' : '';

    return `${symbol}, ${prefix}${formatPercent(price.percentPriceChange)}%`;
  };

  unSubscribeAll = () => {
    MessageHub.unsubscribe(ChanelConfig.TickChanel, this.onReceiveTicker);
    MessageHub.unsubscribe(
      ChanelConfig.DerivativeChannel,
      this.onReceiveDerivative,
    );
    MessageHub.unsubscribe(ChanelConfig.IndexChannel, this.onReceiveIndex);
    MessageHub.unsubscribe(
      ChanelConfig.CoveredWarrantChannel,
      this.onReceiveCW,
    );
  };

  getSymbolType = symbolCode => {
    const symbol = symbolCode || this.getCurrentSymbol();
    const listOrganizationByTicker = store.getState()[COMMON_REDUCER_NAME]
      .listOrganizationByTicker;
    const listCoveredWarrantByCode = store.getState()[COMMON_REDUCER_NAME]
      .coveredWarrantDataByCode;
    const listIndexByCode = store.getState()[COMMON_REDUCER_NAME]
      .listCompanyGroupByComGroupCode;
    const listSectorByCode = store.getState()[COMMON_REDUCER_NAME]
      .listAllIndustryByIcbCode;

    if (listOrganizationByTicker[symbol]) {
      return SYMBOL_TYPES.STOCK;
    }

    if (listIndexByCode[symbol]) {
      return SYMBOL_TYPES.INDICES;
    }

    if (listCoveredWarrantByCode[symbol]) {
      return SYMBOL_TYPES.COVERED_WARRANT;
    }

    if (listSectorByCode[icbTickerToCode[symbol]]) {
      return SYMBOL_TYPES.SECTOR;
    }

    return SYMBOL_TYPES.FUTURES;
  };

  subscribePriceChange = () => {
    const symbolType = this.getSymbolType();
    switch (symbolType) {
      default:
      case SYMBOL_TYPES.STOCK:
        MessageHub.subscribe(ChanelConfig.TickChanel, this.onReceiveTicker);
        break;
      case SYMBOL_TYPES.INDICES:
        MessageHub.subscribe(ChanelConfig.IndexChannel, this.onReceiveIndex);
        break;
      case SYMBOL_TYPES.FUTURES:
        MessageHub.subscribe(
          ChanelConfig.DerivativeChannel,
          this.onReceiveDerivative,
        );
        break;
      case SYMBOL_TYPES.COVERED_WARRANT:
        MessageHub.subscribe(
          ChanelConfig.CoveredWarrantChannel,
          this.onReceiveCW,
        );
        break;
      case SYMBOL_TYPES.SECTOR:
        MessageHub.subscribe(ChanelConfig.SectorChanel, this.onReceiveIndex);
        break;
    }
  };

  setDocumentTitle = () => {
    const {
      isNewWindow,
      listOrganizationByTicker,
      listDerivativeByDerivativeCode,
    } = this.props;
    if (!isNewWindow) {
      return;
    }
    const symbol = this.getCurrentSymbol();
    this.symbol = symbol;
    const organization = listOrganizationByTicker[symbol];
    const derivative = Object.values(listDerivativeByDerivativeCode).find(
      item => item.organCode === symbol,
    );
    let code = symbol;
    if (organization) {
      code = organization.organCode;
    }
    if (derivative) {
      code = derivative.derivativeCode;
    }
    if (icbTickerToCode[code]) {
      code = icbTickerToCode[code];
    }

    // priceDataService
    //   .getLatestPrice({
    //     Code: code,
    //   })
    //   .then(res => {
    //     const result = res.items[0].priceInfo || {};
    //     document.title = this.getDocumentTitle(symbol, result);
    //   });
    this.unSubscribeAll();
    this.subscribePriceChange();
  };

  onReceivePostMessage = event => {
    console.log(1);
    if (event.data === 'login successfully') {
      this.loadTemplate();
    }
  };

  onSyncSearch = data => {
    const { syncType, id } = this.props;
    if (
      syncType === TYPE_DISABLE ||
      data.syncType !== syncType ||
      id === data.componentId
    ) {
      return;
    }
    console.log(data.search);
    const ticker = data.search.isDerivatives
      ? data.search.organCode
      : data.search.ticker; //organCode;

    setTimeout(() => {
      this.tvWidget.chart().setSymbol(ticker, () => {});
    }, 0);
  };

  getChartScreenShot = async () => {
    const { id } = this.props;
    const image = await takeScreenShot(this.tvWidget);
    EventEmitter.dispatch(CHARTING_SCREEN_SHOT_READY, { [id]: image });
  };

  onGlStateChanged = () => {
    const { glContainer } = this.props;
    if (this.prevIsMaximised !== glContainer.parent.parent.isMaximised) {
      this.initTradingView();
      this.prevIsMaximised = glContainer.parent.parent.isMaximised;
    }
  };

  calcSize = () => {
    this.getRootSize().then(({ width, height }) => {
      this.width = width;
      this.height = height;
    });
  };

  reInitChartWhenLayoutChange = () => {
    if (!this.rootRef.current) {
      return;
    }
    this.getRootSize().then(({ width, height }) => {
      if (width !== this.width || height !== this.height) {
        this.initTradingView();
        this.width = width;
        this.height = height;
      }
    });
  };

  getRootSize = () =>
    new Promise(resolve => {
      this.sizeTimeout = setTimeout(() => {
        const { width, height } = this.rootRef.current.getBoundingClientRect();

        resolve({ width, height });
      }, 0);
    });

  getContainerId = () => {
    const { id, containerId } = this.props;
    return `${id}_${containerId}`;
  };

  getI18nText = key => {
    const { i18n } = this.props;
    const savedData = this.getSavedData();
    const locale = this.getLocale(savedData);

    return getDataFollowKeyByDot(i18n.translations[locale], key);
  };

  loadTemplate = () => {
    const { fetchTemplateRequest } = this.props;
    fetchTemplateRequest();
  };

  changeLoadPopupStatus = (bool = true) => {
    this.setState({
      isShowLoadTemplatePopup: bool,
    });
  };

  changeSaveTemplateStatus = (bool = true) => {
    const { user } = this.props;
    if (isNotLogin(user)) {
      return this.showGuestPopup();
    }
    this.setState({
      isShowSaveTemplate: bool,
    });
  };

  changeSharePopupStatus = (bool = true) => {
    const { user } = this.props;
    if (isNotLogin(user)) {
      return this.showGuestPopup();
    }
    this.setState({
      isShowShare: bool,
    });
  };

  getDefaultSymbol = () => {
    const { dragCode, defaultSymbol, id } = this.props;
    // const syncType = this.getChartingSyncType();

    // if (syncType === TYPE_DISABLE) {
    //   const symbol = currentState.get(
    //     CommonConst.listComponent.Charting,
    //     'symbol',
    //     id,
    //   );
    //   if (symbol) return symbol;
    // }
    if (dragCode) {
      return dragCode.isDerivatives ? dragCode.organCode : dragCode.displayCode;
    }
    const defaultSearch = getSyncDefaultSearch(
      ConstCommon.listComponent.Charting,
    );

    return defaultSearch && defaultSearch.displayCode
      ? defaultSearch.derivativeCode
        ? defaultSearch.organCode
        : defaultSearch.displayCode
      : defaultSymbol;
  };

  initTradingView = () => {
    const {
      theme,
      interval,
      libraryPath,
      chartsStorageUrl,
      chartsStorageApiVersion,
      clientId,
      userId,
      fullscreen,
      dragCode,
      i18n,
    } = this.props;
    if (!this.rootRef.current) {
      return;
    }

    // Clear local data when init charting
    clearPrevFromParams();
    EventEmitter.dispatch(TRADING_VIEW_WRAPPER_DATA_RESET, {});

    // Get symbol
    const symbol = this.getDefaultSymbol();
    this.setState({
      code: symbol,
    });
    EventEmitter.dispatch(TRADING_VIEW_WRAPPER_DATA_MAIN_SYMBOL, symbol);
    setSymbolOrganCodeType(this.getSymbolType(symbol));

    // Before charting init
    const savedData = dragCode ? null : this.getSavedData();
    const widgetOptions = {
      ...commonConfig,
      ...customConfig,
      locale: this.getLocale(savedData),
      symbol,
      custom_indicators_getter: customIndicatorsGetter(i18n.locale),
      datafeed: DataFeed,
      interval: interval,
      container: this.getContainerId(),
      library_path: libraryPath,
      charts_storage_url: chartsStorageUrl,
      charts_storage_api_version: chartsStorageApiVersion,
      client_id: clientId,
      user_id: userId,
      fullscreen: fullscreen,
      snapshot_url: linkUrlConfig.trading_view_snapshot_url,
      overrides: getOverrides(theme),
      loading_screen: {
        backgroundColor: theme === THEMES.DARK ? '#1F2329' : '#ffffff',
      },
      theme:
        savedData && savedData.theme
          ? savedData.theme
          : capitalizeFirstLetter(theme),
      ...(savedData ? { saved_data: savedData } : {}),
    };
    this.tvWidget = new window.TradingView.widget(widgetOptions);

    // After charting init
    this.tvWidget.onChartReady(() => {
      //this.setDocumentTitle();
      getStudiesOverrides(this.tvWidget);
      this.tvWidget.applyOverrides(getOverrides(theme));
      this.tvWidget.headerReady().then(() => {
        this.addLoadTemplateBtn(this.tvWidget);
        this.addSaveTemplateBtn(this.tvWidget);
        // this.addStockMapLinkBtn(this.tvWidget);
        // this.addFidtLinkBtn(this.tvWidget);
        this.addShareBtn(this.tvWidget);
      });

      const isSmallScreen = isMobile() || isSmallThanWidth(576);
      if (isSmallScreen) {
        this.tvWidget.chart().setTimeFrame({
          val: { type: 'period-back', value: '3M' },
          res: '1D',
        });
      }

      // Subscribe
      this.tvWidget.subscribe('onAutoSaveNeeded', this.onAutoSaveNeeded);
      this.tvWidget.subscribe('study', this.onAddIndicator);
      this.tvWidget
        .chart()
        .onSymbolChanged()
        .subscribe(null, this.onSymbolChanged);
      // const interval = this.tvWidget.activeChart().resolution();
      // const timeframe = getTimeFrameObj(interval);
      // if (timeframe) {
      //   console.log(timeframe);

      //   this.tvWidget.chart().setTimeFrame({
      //     val: timeframe,
      //     res: interval,
      //   });
      // }
      this.tvWidget
        .activeChart()
        .onIntervalChanged()
        .subscribe(null, (interval, timeframeObj) => {
          clearPrevFromParams();
          EventEmitter.dispatch(TRADING_VIEW_WRAPPER_DATA_RESET, {
            isSymbolChange: false,
          });
          EventEmitter.dispatch(TRADING_VIEW_WRAPPER_DATA_RESOLUTION, interval);
          // this.tvWidget.activeChart().resetData();
          // const { timeframe, fromOption } = getTimeFrameObj(interval);
          // if (timeframe) {
          //   timeframeObj.timeframe = timeframe;
          //   // this.tvWidget.chart().setTimeFrame({
          //   //   val: timeframe,
          //   //   res: interval,
          //   // });
          // }
          // if (fromOption) {
          //   this.tvWidget.activeChart().setVisibleRange({
          //     from: moment()
          //       .subtract(fromOption.number, fromOption.unit)
          //       .unix(),
          //     to: new Date().getTime() / 1000,
          //   });
          // }
          this.tvWidget.activeChart().executeActionById('timeScaleReset');
          this.tvWidget.chart().executeActionById('ChartPriceScaleReset');
        });

      EventEmitter.subscribe(
        TRADING_VIEW_WIDGET_RESET_DATA,
        this.onWidgetResetData,
      );
    });
  };

  onWidgetResetData = () => {
    this.tvWidget.activeChart().resetData();
  };

  onSymbolChanged = symbol => {
    const { isNewWindow } = this.props;
    //this.setDocumentTitle();
    this.saveTVLayout(symbol.displayCode);
    clearPrevFromParams();
    EventEmitter.dispatch(TRADING_VIEW_WRAPPER_DATA_RESET, {
      isSymbolChange: true,
      symbol: symbol.ticker,
    });
    EventEmitter.dispatch(TRADING_VIEW_WRAPPER_DATA_MAIN_SYMBOL, symbol.ticker);
    setSymbolOrganCodeType(symbol.type);

    // const overrides = {
    //   'mainSeriesProperties.style': 1,
    // };
    // if (symbol.type === SYMBOL_TYPES.ECONOMY) {
    //   overrides['mainSeriesProperties.style'] = 2;
    // }
    // this.tvWidget.applyOverrides(overrides);
    // this.tvWidget.activeChart().executeActionById('timeScaleReset');
    this.tvWidget.chart().executeActionById('ChartPriceScaleReset');
    this.changeUrlIfNeeded(symbol);
    if (!isNewWindow) {
      this.dispatchSyncSearch(symbol);
    }
    this.setState({
      code: symbol.code,
    });
    this.onSetSymbolTypesDefault();

    window.parent.postMessage(
      { type: 'CHANGE_CODE', ticker: symbol.ticker },
      '*',
    );
  };

  getCurrentSearchFromSymbol = symbol => {
    const {
      listOrganizationByTicker,
      listEconomyByEconomyCode,
      listDerivativeByDerivativeCode,
      listCompanyGroupByComGroupCode,
      listAllIndustryByIcbCode,
      coveredWarrantDataByCode,
    } = this.props;
    switch (symbol.type) {
      case SYMBOL_TYPES.STOCK:
        return listOrganizationByTicker[symbol.ticker];
      case SYMBOL_TYPES.INDICES:
        return listCompanyGroupByComGroupCode[symbol.ticker];
      case SYMBOL_TYPES.ECONOMY:
        return listEconomyByEconomyCode[symbol.ticker];
      case SYMBOL_TYPES.SECTOR:
        return listAllIndustryByIcbCode[symbol.code];
      case SYMBOL_TYPES.COVERED_WARRANT:
        return coveredWarrantDataByCode[symbol.ticker];
      case SYMBOL_TYPES.FUTURES:
        const symbolObject = Object.values(listDerivativeByDerivativeCode).find(
          item => item.organCode === symbol.ticker,
        );

        return symbolObject || {};
      default:
        return {};
    }
  };

  dispatchSyncSearch = symbol => {
    const { syncType, id } = this.props;
    if (symbol.type === SYMBOL_TYPES.ECONOMY || syncType === TYPE_DISABLE) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      syncType: syncType,
      search: this.getCurrentSearchFromSymbol(symbol),
      componentId: id,
    });
  };

  changeUrlIfNeeded = symbol => {
    try {
      const search = window.location.search;
      if (!search) {
        return;
      }
      const query = new URLSearchParams(search);
      if (!query.get('code')) {
        return;
      }
      query.set('code', symbol.ticker);
      const url = `/charting?${query.toString()}`;
      window.history.pushState('', '', url);
    } catch (e) {
      console.log(e);
    }
  };

  onAddIndicator = indicator => {
    if (isQuarterlyData(indicator.value)) {
      this.changeIntervalToWeekly();
    }
  };

  onSetSymbolTypesDefault = () => {
    const symbolType = localStorage.getItem(TRADING_VIEW_SYMBOL_EDIT_FILTER);
    if (symbolType !== 'All') {
      localStorage.setItem(TRADING_VIEW_SYMBOL_EDIT_FILTER, 'All');
    }
  };

  onHideLeftToolbar = isDefaultHideInMobile => {
    const isHide =
      localStorage.getItem(TRADING_VIEW_HIDE_LEFT_TOOLBAR) === 'false';
    const isSmallScreen = isMobile() || isSmallThanWidth(576);
    if (isDefaultHideInMobile && isSmallScreen) {
      localStorage.setItem(TRADING_VIEW_HIDE_LEFT_TOOLBAR, 'false');
      return;
    }
    if (
      this.tvWidget &&
      ((isSmallScreen && !isHide) || (!isSmallScreen && isHide))
    ) {
      this.tvWidget.activeChart().executeActionById('drawingToolbarAction');
    }
  };

  changeIntervalToWeekly = () => {
    this.tvWidget.setSymbol(this.tvWidget.chart().symbol(), '3M', () => {});
  };

  showGuestPopup = () => {
    EventEmitter.dispatch(SHOW_GUEST_POPUP);
  };

  addSaveTemplateBtn = tvWidget => {
    const button = tvWidget.createButton();
    if (button) {
      button.setAttribute('title', this.getI18nText('charting.saveTemplate'));
      button.classList.add('apply-common-tooltip');
      button.innerHTML = this.getI18nText('charting.saveTemplate');
      button.addEventListener('click', () => {
        this.changeSaveTemplateStatus();
      });
    }
  };

  addLoadTemplateBtn = tvWidget => {
    const button = tvWidget.createButton();
    if (button) {
      button.setAttribute('title', this.getI18nText('charting.loadTemplate'));
      button.classList.add('apply-common-tooltip');
      button.innerHTML = this.getI18nText('charting.loadTemplate');
      button.addEventListener('click', () => {
        this.changeLoadPopupStatus();
      });
    }
  };

  addShareBtn = tvWidget => {
    const button = tvWidget.createButton({ align: 'right' });
    if (button) {
      button.setAttribute('title', this.getI18nText('charting.shareTemplate'));
      button.classList.add('apply-common-tooltip');
      button.innerHTML = this.getI18nText('charting.share');
      button.addEventListener('click', () => {
        this.changeSharePopupStatus();
      });
    }
  };

  onAutoSaveNeeded = () => {
    setTimeout(() => {
      this.saveTVLayout();
    }, 0);
  };

  saveTVLayout = symbolCode => {
    const {
      theme,
      id,
      saveLayout,
      isShareLink,
      isNewWindow,
      user,
    } = this.props;
    this.tvWidget.save(chartState => {
      chartState.theme = capitalizeFirstLetter(theme);
      if (!isShareLink) {
        localStorage.setItem(
          CHARTING_LOCAL_STORAGE_KEY,
          JSON.stringify(chartState),
        );
      }
      if (isNewWindow) {
        return;
      }
      currentState.add(
        CommonConst.listComponent.Charting,
        'chartState',
        JSON.stringify(chartState),
        id,
      );
      if (symbolCode) {
        currentState.add(
          CommonConst.listComponent.Charting,
          'symbol',
          symbolCode,
          id,
        );
      }
      if (!isNotLogin(user)) {
        saveLayout();
      }
    });
  };

  getChartingSyncType = () => {
    const { id } = this.props;
    const state = getSyncComponentState();
    return state[CommonConst.listComponent.Charting][id];
  };

  getSavedData = () => {
    const {
      id,
      savedData,
      isShareLink,
      isNewWindow,
      defaultSymbol,
    } = this.props;
    if (isShareLink) {
      return savedData;
    }
    const chartStateString = currentState.get(
      CommonConst.listComponent.Charting,
      'chartState',
      id,
    );
    if (!chartStateString) {
      let stateFromLocal = localStorage.getItem(CHARTING_LOCAL_STORAGE_KEY);
      if (!stateFromLocal) {
        return null;
      }

      if (isNewWindow && !isShareLink) {
        stateFromLocal = stateFromLocal.replace(
          /"symbol":".+?","shortName":".+?"/,
          `"symbol":"${defaultSymbol}","shortName":"${defaultSymbol}"`,
        );
      }

      return JSON.parse(stateFromLocal);
    }

    return JSON.parse(chartStateString);
  };

  getLocale = savedData => {
    const { i18n } = this.props;

    return savedData && savedData.locale ? savedData.locale : i18n.locale;
  };

  render() {
    const {
      isShowLoadTemplatePopup,
      isShowSaveTemplate,
      isShowShare,
    } = this.state;

    return (
      <Provider value={this.tvWidget}>
        <div ref={this.rootRef} className="h-100 position-relative">
          <div id={this.getContainerId()} className="h-100" />

          {isShowLoadTemplatePopup && (
            <LoadTemplatePopup changePopUpStatus={this.changeLoadPopupStatus} />
          )}
          {isShowSaveTemplate && (
            <SaveTemplatePopup
              changeSaveTemplateStatus={this.changeSaveTemplateStatus}
            />
          )}
          {isShowShare && (
            <SharePopup changeSharePopupStatus={this.changeSharePopupStatus} />
          )}
          <WrapperData />
        </div>
      </Provider>
    );
  }
}

TradingView.propTypes = {
  theme: PropTypes.string.isRequired,
  fetchTemplateRequest: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
  isShareLink: PropTypes.bool,
  loadUserAndRemountChart: PropTypes.func,
};

TradingView.defaultProps = {
  interval: 'D',
  libraryPath: '/chart/charting_library/',
  fullscreen: false,
  studiesOverrides: {},
  containerId: 'charting',
  clientId: 'tradingview.com',
  userId: 'public_user_id',
  isNewWindow: false,
  defaultSymbol: DEFAULT_SYMBOL,
  chartsStorageUrl: '',
  chartsStorageApiVersion: '1.1',
  isShareLink: false,
  loadUserAndRemountChart: () => {},
};

const mapStateToProps = (state, { id }) => ({
  theme: state.theme,
  i18n: state.i18n,
  listOrganizationByTicker: state[COMMON_REDUCER_NAME].listOrganizationByTicker,
  listEconomyByEconomyCode: state[COMMON_REDUCER_NAME].listEconomyByEconomyCode,
  listDerivativeByDerivativeCode:
    state[COMMON_REDUCER_NAME].listDerivativeByDerivativeCode,
  listCompanyGroupByComGroupCode:
    state[COMMON_REDUCER_NAME].listCompanyGroupByComGroupCode,
  listAllIndustryByIcbCode: state[COMMON_REDUCER_NAME].listAllIndustryByIcbCode,
  coveredWarrantDataByCode: state[COMMON_REDUCER_NAME].coveredWarrantDataByCode,

  syncType: syncComponentSelector(
    state,
    CommonConst.listComponent.Charting,
    id,
  ),
  syncSearch: state[COMMON_REDUCER_NAME].syncComponentSearch,
  user: state.userInfo,
});
const mapDispatchToProps = {
  fetchTemplateRequest,
  getDataFollowKeyByDot,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TradingView);
